import { useDispatch } from "react-redux";
import styled from "styled-components";
import { FaTimes } from "react-icons/fa";

import { AppDispatch } from "../../store";
import { hideSingleJobDetails } from "../../features/allJobs/allJobsSlice";
import { capitalize } from "../../utils/capitalize";
import { convertNewLines } from "../../utils/convertNewLines";

interface SingleJobDetailsProps {
  position: string;
  company: string;
  jobDescription: string;
  jobType: string;
  jobStatus: string;
}

const SingleJobDetails = ({
  position,
  company,
  jobDescription,
  jobType,
  jobStatus,
}: SingleJobDetailsProps) => {
  const dispatch = useDispatch<AppDispatch>();

  // Function to convert newlines to <br> tags
  const convertNewLinesToBreak = (text: string) => {
    return convertNewLines(text);
  };

  const firstChar = company?.charAt(0);

  return (
    <DescriptionWrapper onClick={() => dispatch(hideSingleJobDetails())}>
      <div onClick={(e) => e.stopPropagation()}>
        {/* "stopPropagation" is to make sure that "hideSingleJobDetails" is not triggered when just this div is clicked */}
        <FaTimes
          className="close__modal"
          onClick={() => dispatch(hideSingleJobDetails())}
        />
        <header className="title__header">
          <h1>{position}</h1>
          <p>@{company}</p>
        </header>
        <div className="char__header">
          <p>{firstChar}</p>
        </div>
        <h2 style={{ textAlign: "center" }}>Job Description</h2>
        <hr style={{ marginBlock: "4px", opacity: "0.4" }} />
        <p style={{ fontSize: "16px" }}>
          {convertNewLinesToBreak(jobDescription)}
        </p>
        <footer className="footer__content">
          <p>{capitalize(jobType)}</p>
          <span
            className={`${
              jobStatus === "interview"
                ? "addInterviewColor"
                : jobStatus === "pending"
                ? "addPendingColor"
                : "addDelineColor"
            }`}
          >
            {capitalize(jobStatus)}
          </span>
        </footer>
      </div>
    </DescriptionWrapper>
  );
};

export default SingleJobDetails;

const DescriptionWrapper = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  padding-inline: 1rem;
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  > div {
    position: relative;
    max-width: 700px;
    max-height: 90vh;
    background-color: #fff;
    margin: 2rem auto;
    border-radius: 8px;
    padding: 2rem 1.5rem;
    overflow-y: auto;
    z-index: 99;
  }

  .close__modal {
    position: absolute;
    right: 8px;
    top: 8px;
    color: #b93815;
    font-size: 2rem;
    cursor: pointer;
    z-index: 999;
  }

  .title__header {
    margin-top: 1rem;
    text-align: center;
  }
  .title__header > h1 {
    color: var(--dark);
    font-size: 2rem;
  }
  .title__header > p {
    font-weight: 600;
  }

  .char__header {
    background-color: var(--dark);
    color: #fff;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-inline: auto;
    font-weight: 700;
    font-size: 36px;
    margin-block: 1rem;
  }
  @media screen and (max-width: 640px) {
    .char__header {
      width: 75px;
      height: 75px;
      border-radius: 50%;
      font-size: 24px;
    }
    .title__header > h1 {
      font-size: 1.2rem;
    }
  }

  .footer__content {
    display: flex;
    justify-content: space-between;
    align-items: "center";
    margin-top: 1rem;
  }
  .footer__content > p {
    font-size: 18;
    font-weight: 600;
  }
  .footer__content > span {
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
  }
  /* Add status color */
  .addInterviewColor {
    background-color: var(--InterviewColor);
  }
  .addPendingColor {
    background-color: var(--pendingColor);
  }
  .addDelineColor {
    background-color: var(--DeclineColor);
  }
`;
